import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../utility/AuthContext";
import "../assets/sidebar.css";

export default function Sidebar({ sidebarCollapsed }) {
  const navigate = useNavigate();
  const [masterDropdown, setMasterDropdown] = useState(false);
  const [reportDropdown, setReportDropdown] = useState(false);
  const { user } = useContext(AuthContext);
  return (
    <div
      className="d-flex flex-column bg-white border-end pt-5"
      style={{
        width: sidebarCollapsed ? "0px" : "250px",
        height: "100vh",
        transition: "width 0.3s ease",
        fontSize: "1.1rem",
      }}
    >
      <ul className="nav flex-column mt-3">
        <li
          className="nav-item px-3 mb-2 sidebar-item"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          <i className="bi bi-briefcase-fill me-2 text-success"></i>
          <span>{!sidebarCollapsed && "Dashboard"}</span>
        </li>

        {user.role === "Admin" && (
          <>
            <li
              className="nav-item px-3 mb-2 py-2 rounded d-flex flex-row justify-content-between sidebar-item"
              onClick={() => setMasterDropdown(!masterDropdown)}
            >
              <span>
                <i className="bi bi-briefcase-fill me-2 text-success"></i>
                {!sidebarCollapsed && "Master"}
              </span>
              <i
                className={`bi bi-arrow-${masterDropdown ? "up" : "down"} me-3`}
              ></i>
            </li>

            <ul
              className={`list-unstyled ps-5 text-dark ${
                masterDropdown ? "d-block" : "d-none"
              }`}
            >
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/doctor-master");
                }}
              >
                {!sidebarCollapsed && "Doctor Master"}
              </li>
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/problem-master");
                }}
              >
                {!sidebarCollapsed && "Problem Master"}
              </li>
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/test-master");
                }}
              >
                {!sidebarCollapsed && "Test Master"}
              </li>
            </ul>
          </>
        )}
        {user.role === "Operator" && (
          <>
            <li
              className="nav-item px-3 mb-2 sidebar-item"
              onClick={() => navigate("/counter-registration")}
            >
              <i className="bi bi-briefcase-fill me-2 text-success"></i>
              <span>{!sidebarCollapsed && "Counter Registration"}</span>
            </li>

            <li
              className="nav-item px-3 mb-2 sidebar-item"
              onClick={() => navigate("/follow-up")}
            >
              <i className="bi bi-briefcase-fill me-2 text-success"></i>
              <span>{!sidebarCollapsed && "Follow Up"}</span>
            </li>

            <li
              className="nav-item px-3 mb-2 sidebar-item"
              onClick={() => navigate("/cancel-appointment")}
            >
              <i className="bi bi-briefcase-fill me-2 text-success"></i>
              <span>{!sidebarCollapsed && "Cancel Appointment"}</span>
            </li>

            <li
              className="nav-item px-3 mb-2 sidebar-item"
              onClick={() => navigate("/refund")}
            >
              <i className="bi bi-briefcase-fill me-2 text-success"></i>
              <span>{!sidebarCollapsed && "Refund"}</span>
            </li>
          </>
        )}
        {user.role === "Doctor" && (
          <li
            className="nav-item px-3 mb-2 sidebar-item"
            onClick={() => navigate("/waiting")}
          >
            <i className="bi bi-briefcase-fill me-2 text-success"></i>
            <span>{!sidebarCollapsed && "Waiting Patients"}</span>
          </li>
        )}

        <li
          className="nav-item px-3 mb-2 py-2 rounded d-flex flex-row justify-content-between sidebar-item"
          onClick={() => setReportDropdown(!reportDropdown)}
        >
          <span>
            <i className="bi bi-briefcase-fill me-2 text-success"></i>
            {!sidebarCollapsed && "Reports"}
          </span>
          <i
            className={`bi bi-arrow-${reportDropdown ? "up" : "down"} me-3`}
          ></i>
        </li>

        <ul
          className={`list-unstyled ps-5 text-dark ${
            reportDropdown ? "d-block" : "d-none"
          }`}
        >
          {(user.role === "Operator" || user.role === "Admin") && (
            <>
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/daily-collection-report");
                }}
              >
                {!sidebarCollapsed && "Daily Collection Report"}
              </li>
              <li
                className="text-secondary sidebar-list-item"
                onClick={() => {
                  navigate("/test-wise-report");
                }}
              >
                {!sidebarCollapsed && "Test Wise Report"}
              </li>
            </>
          )}
          <li
            className="text-secondary sidebar-list-item"
            onClick={() => {
              navigate("/doctor-wise-report");
            }}
          >
            {!sidebarCollapsed && "Doctor Wise Report"}
          </li>
        </ul>
      </ul>
    </div>
  );
}
